"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioAttachment;

function AudioAttachment(_ref) {
  var avatarSize = _ref.avatarSize;
  return {
    // TODO: [P2] We should not set "display" in styleSet, this will allow the user to break the layout for no good reasons.
    display: 'flex',
    minHeight: avatarSize
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBdWRpb0F0dGFjaG1lbnQiLCJhdmF0YXJTaXplIiwiZGlzcGxheSIsIm1pbkhlaWdodCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0eWxlcy9TdHlsZVNldC9BdWRpb0F0dGFjaG1lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQXVkaW9BdHRhY2htZW50KHsgYXZhdGFyU2l6ZSB9OiBTdHJpY3RTdHlsZU9wdGlvbnMpIHtcbiAgcmV0dXJuIHtcbiAgICAvLyBUT0RPOiBbUDJdIFdlIHNob3VsZCBub3Qgc2V0IFwiZGlzcGxheVwiIGluIHN0eWxlU2V0LCB0aGlzIHdpbGwgYWxsb3cgdGhlIHVzZXIgdG8gYnJlYWsgdGhlIGxheW91dCBmb3Igbm8gZ29vZCByZWFzb25zLlxuICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICBtaW5IZWlnaHQ6IGF2YXRhclNpemVcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVlLFNBQVNBLGVBQVQsT0FBNkQ7RUFBQSxJQUFsQ0MsVUFBa0MsUUFBbENBLFVBQWtDO0VBQzFFLE9BQU87SUFDTDtJQUNBQyxPQUFPLEVBQUUsTUFGSjtJQUdMQyxTQUFTLEVBQUVGO0VBSE4sQ0FBUDtBQUtEIn0=